module.exports = __webpack_public_path__ + "static/media/botThread.dcbe07a6.svg";